import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import LayoutAnalise, { layoutAnaliseType } from '../../components/layoutAnalise/LayoutAnalise';
import InputPergunta from '../../components/analiseNegocialMetodologica/inputPergunta/InputPergunta';
import InputGroupPergunta from '../../components/analiseNegocialMetodologica/inputGroupPergunta/InputGroupPergunta';
import styles from './AnaliseMetodologicaForm.module.scss';
import Radio from '../../../../core/components/inputs/radio/Radio';
import { useFormik } from 'formik';
import InputField from '../../../../components/inputField/InputField';
import { InputTextarea } from 'primereact/inputtextarea';
import Checkbutton from '../../../../core/components/inputs/checkbutton/Checkbutton';
import { useHistory, useParams } from 'react-router-dom';
import Pages from '../../../../config/Pages';
import { usePerguntas } from '../../components/analiseNegocialMetodologica/Hooks';
import analiseMetodologicaService from '../../../../service/AnaliseMetodologicaService';
import { arrayToDateString } from '../../../../core/utils/DateMixins';
import { printToast } from '../../../../core/utils/Global';
import Shareds from '../../../../config/translations/Shareds';
import ConfirmDialog from '../../../../core/components/ConfirmDialog';
import PageMessages from '../../../../config/translations/PageMessages';
import { errosTratados } from '../../../../config/Axios';
import { isEmpty } from '../../../../core/utils/ValidForm';
import InputTextLengthCounter from '../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';

const TextArea = forwardRef(({ name, disabled = false }, ref) => {
    const formik = useFormik({ initialValues: { [name]: '' } });
    useImperativeHandle(
        ref,
        () => ({
            [name]: formik.values?.[name],
            setValue: (value) => formik.setFieldValue(name, value ?? ''),
        }),
        [formik.values]
    );
    return (
        <InputField
            className={styles.textarea}
            formik={formik}
            id={name}
            label="MANIFESTAÇÃO TÉCNICA:"
            required
        >
            <InputTextLengthCounter maxLen={3500}>
                <InputTextarea
                    name={name}
                    value={formik?.values?.[name]}
                    onChange={formik.handleChange}
                    rows={4}
                    disabled={disabled}
                />
            </InputTextLengthCounter>
        </InputField>
    );
});

const Check = forwardRef(({ name, label, ...rest }, ref) => {
    const formik = useFormik({ initialValues: { [name]: null } });
    useImperativeHandle(
        ref,
        () => ({
            [name]: formik.values?.[name],
            setValue: (value) => {
                formik.setFieldValue(name, value);
            },
        }),
        [formik.values?.[name]]
    );
    return (
        <Checkbutton
            hasBollean
            name={name}
            formik={formik}
            label={label}
            onChange={() => {
                const value = !(formik.values?.[name] === true);
                return formik.setFieldValue(name, value === false ? null : value);
            }}
            {...rest}
        />
    );
});

const FormBottom = forwardRef(({ disabled = false, codgTipoProposta }, ref) => {
    const formik = useFormik({ initialValues: { flagValidacao: null } });
    const valores = useRef({});

    useImperativeHandle(
        ref,
        () => ({
            getValues: () => ({
                ...Object.values(valores.current).reduce((prev, curr) => {
                    const [key] = Object.keys(curr);
                    prev[key] = curr[key];
                    return prev;
                }, {}),
                ...formik.values,
            }),
            setFieldValue: (name, value) => {
                if (name === 'flagValidacao') {
                    return formik.setFieldValue('flagValidacao', value);
                } else {
                    valores.current?.[name]?.setValue(value);
                }
            },
        }),
        [formik.values, valores.current]
    );

    return (
        <>
            <div className={styles.containerCards}>
                <div>
                    <div>
                        <Radio
                            className={styles.title}
                            name="flagValidacao"
                            value={'VALIDADO'}
                            formik={formik}
                            label="VALIDADO"
                            onChange={(ev) => {
                                formik.setFieldValue('flagValidacao', ev.value);
                                valores.current['flagFichaPreeConformidadeNao'].setValue(null);
                                valores.current['flagPropriedadeDesejavelNao'].setValue(null);
                                valores.current['flagParecerAdqAderenciaObjNao'].setValue(null);
                                if (codgTipoProposta === 'ALTERACAO_INDICADOR') {
                                    valores.current['flagFichaPreeConformidadeDescartado'].setValue(
                                        null
                                    );
                                    valores.current['flagPropriedadeDesejavelDescartado'].setValue(
                                        null
                                    );
                                    valores.current[
                                        'flagParecerAdqAderenciaObjDescartado'
                                    ].setValue(null);
                                }
                            }}
                            disabled={disabled}
                        />
                        <div>
                            Este indicador atende aos requisitos exigidos pela Metodologia de
                            Indicadores, possuindo:
                        </div>
                        <Check
                            disabled={formik.values?.flagValidacao !== 'VALIDADO' || disabled}
                            name="flagFichaPreeConformidade"
                            label="Ficha de Metadados preenchida em conformidade com a Metodologia"
                            ref={(el) => (valores.current['flagFichaPreeConformidade'] = el)}
                        />
                        <Check
                            disabled={formik.values?.flagValidacao !== 'VALIDADO' || disabled}
                            name="flagPropriedadeDesejavel"
                            label="Verificação de propriedades desejáveis do Indicador"
                            ref={(el) => (valores.current['flagPropriedadeDesejavel'] = el)}
                        />
                        <Check
                            disabled={formik.values?.flagValidacao !== 'VALIDADO' || disabled}
                            name="flagParecerAdqAderenciaObj"
                            label="Parecer positivo de adequabilidade e aderência aos objetivos do instrumento o que se propõe mensurar"
                            ref={(el) => (valores.current['flagParecerAdqAderenciaObj'] = el)}
                        />
                    </div>
                </div>
                <div>
                    <div>
                        <Radio
                            className={styles.title}
                            name="flagValidacao"
                            formik={formik}
                            value={'NAO_VALIDADO'}
                            onChange={(ev) => {
                                formik.setFieldValue('flagValidacao', ev.value);
                                valores.current['flagFichaPreeConformidade'].setValue(null);
                                valores.current['flagPropriedadeDesejavel'].setValue(null);
                                valores.current['flagParecerAdqAderenciaObj'].setValue(null);
                                if (codgTipoProposta === 'ALTERACAO_INDICADOR') {
                                    valores.current['flagFichaPreeConformidadeDescartado'].setValue(
                                        null
                                    );
                                    valores.current['flagPropriedadeDesejavelDescartado'].setValue(
                                        null
                                    );
                                    valores.current[
                                        'flagParecerAdqAderenciaObjDescartado'
                                    ].setValue(null);
                                }
                            }}
                            label="NÃO VALIDADO"
                            disabled={disabled}
                        />
                        <div>
                            Este indicador NÃO atende aos requisitos exigidos pela Metodologia de
                            Indicadores, pelos seguintes motivos:
                        </div>
                        <Check
                            disabled={formik.values?.flagValidacao !== 'NAO_VALIDADO' || disabled}
                            name="flagFichaPreeConformidadeNao"
                            label="Não possui Ficha de Metadados preenchida em conformidade com a Metodologia"
                            ref={(el) => (valores.current['flagFichaPreeConformidadeNao'] = el)}
                        />
                        <Check
                            disabled={formik.values?.flagValidacao !== 'NAO_VALIDADO' || disabled}
                            name="flagPropriedadeDesejavelNao"
                            label="Não apresenta verificação de propriedades desejáveis do Indicador"
                            ref={(el) => (valores.current['flagPropriedadeDesejavelNao'] = el)}
                        />
                        <Check
                            disabled={formik.values?.flagValidacao !== 'NAO_VALIDADO' || disabled}
                            name="flagParecerAdqAderenciaObjNao"
                            label="Não possui parecer positivo de adequabilidade e aderência aos objetivos do instrumento o que se propõe mensurar"
                            ref={(el) => (valores.current['flagParecerAdqAderenciaObjNao'] = el)}
                        />
                    </div>
                </div>
                {codgTipoProposta === 'ALTERACAO_INDICADOR' && (
                    <div>
                        <div>
                            <Radio
                                className={styles.title}
                                name="flagValidacao"
                                formik={formik}
                                value={'NAO_VALIDADO_DESCARTADO'}
                                onChange={(ev) => {
                                    formik.setFieldValue('flagValidacao', ev.value);
                                    valores.current['flagFichaPreeConformidadeNao'].setValue(null);
                                    valores.current['flagPropriedadeDesejavelNao'].setValue(null);
                                    valores.current['flagParecerAdqAderenciaObjNao'].setValue(null);
                                    valores.current['flagFichaPreeConformidade'].setValue(null);
                                    valores.current['flagPropriedadeDesejavel'].setValue(null);
                                    valores.current['flagParecerAdqAderenciaObj'].setValue(null);
                                }}
                                label="NÃO VALIDADO / DESCARTAR ALTERAÇÃO"
                                disabled={disabled}
                            />
                            <div>
                                Este indicador NÃO atende aos requisitos exigidos pela Metodologia
                                de Indicadores, pelos seguintes motivos:
                            </div>
                            <Check
                                disabled={
                                    formik.values?.flagValidacao !== 'NAO_VALIDADO_DESCARTADO' ||
                                    disabled
                                }
                                name="flagFichaPreeConformidadeDescartado"
                                label="Não possui Ficha de Metadados preenchida em conformidade com a Metodologia"
                                ref={(el) =>
                                    (valores.current['flagFichaPreeConformidadeDescartado'] = el)
                                }
                            />
                            <Check
                                disabled={
                                    formik.values?.flagValidacao !== 'NAO_VALIDADO_DESCARTADO' ||
                                    disabled
                                }
                                name="flagPropriedadeDesejavelDescartado"
                                label="Não apresenta verificação de propriedades desejáveis do Indicador"
                                ref={(el) =>
                                    (valores.current['flagPropriedadeDesejavelDescartado'] = el)
                                }
                            />
                            <Check
                                disabled={
                                    formik.values?.flagValidacao !== 'NAO_VALIDADO_DESCARTADO' ||
                                    disabled
                                }
                                name="flagParecerAdqAderenciaObjDescartado"
                                label="Não possui parecer positivo de adequabilidade e aderência aos objetivos do instrumento o que se propõe mensurar"
                                ref={(el) =>
                                    (valores.current['flagParecerAdqAderenciaObjDescartado'] = el)
                                }
                            />
                        </div>
                    </div>
                )}
            </div>
            <div>
                <TextArea
                    name="descManifestacaoTecnica"
                    ref={(el) => (valores.current['descManifestacaoTecnica'] = el)}
                    disabled={disabled}
                />
            </div>
        </>
    );
});

function AnaliseMetodologicaForm() {
    const inputsRef = useRef(null);
    const history = useHistory();
    const perguntasRef = useRef([]);
    const perguntas = usePerguntas(layoutAnaliseType.analiseMetodologica);
    const { id } = useParams();
    const [proposta, setProposta] = useState(null);
    const confirmRef = useRef(null);

    const loadData = async () => {
        const response = await analiseMetodologicaService.buscarPorId({ id });
        const statusAtual =
            (response?.proposta?.propostaStatus ?? []).find((status) => status?.flagAtual) ?? {};
        inputsRef.current.setFieldValue(
            'descManifestacaoTecnica',
            response?.descManifestacaoTecnica ?? ''
        );
        const { tipoValidacaoMetodologica, ...rest } = response?.validacaoMetodologica ?? {};
        let prefix =
            tipoValidacaoMetodologica?.codgTipoValidacaoMetodologica === 'NAO_VALIDADO'
                ? 'Nao'
                : 'Descartado';
        if (tipoValidacaoMetodologica?.codgTipoValidacaoMetodologica === 'VALIDADO') {
            prefix = '';
        }
        const keys = Object.keys(rest);
        inputsRef.current.setFieldValue(
            'flagValidacao',
            tipoValidacaoMetodologica?.codgTipoValidacaoMetodologica
        );

        for (let i = 0; i < response?.respostasAvaliacaoMetodologica?.length; i++) {
            const resposta = response?.respostasAvaliacaoMetodologica[i];
            perguntasRef.current[resposta.propriedadeAvaliacao.id].setRadioValue(
                resposta.flagResposta
            );
            perguntasRef.current[resposta.propriedadeAvaliacao.id].setTextValue(
                resposta.descObservacao ?? ''
            );
        }

        setTimeout(() => {
            for (let i = 0; i < keys?.length; i++) {
                const key = keys[i];
                if (key !== 'id') {
                    inputsRef.current.setFieldValue(`${key}${prefix}`, rest[key]);
                }
            }
        }, 200);

        setProposta({
            numeroProposta: response?.proposta?.id,
            nmIndicador: response?.proposta?.nmIndicador,
            situacaoProposta: response?.proposta?.situacaoProposta?.descSituacao,
            finalizada: response?.situacaoAvaliacao.codgSituacaoAvaliacao === 'ANALISE_FINALIZADA',
            responsavelAnalise: response?.responsavelAnalise?.nomePessoa,
            dataCadastro: arrayToDateString(response?.dataCadastro, true),
            situacaoAvaliacao: response?.situacaoAvaliacao?.descSituacaoAvaliacao,
            codgTipoProposta: response?.proposta?.tipoProposta?.codgTipoProposta,
            file: statusAtual?.arquivo,
        });
    };

    const getAllValues = () => {
        const values = inputsRef.current?.getValues();

        const respostasAvaliacaoMetodologica = Object.keys(perguntasRef.current).reduce(
            (prev, curr) => [
                ...prev,
                {
                    descObservacao: perguntasRef.current[curr]?.text,
                    propriedadeAvaliacao: { id: curr },
                    flagResposta: perguntasRef.current[curr]?.radio,
                },
            ],
            []
        );
        const { descManifestacaoTecnica, flagValidacao, ...rest } = values;

        const keys = Object.keys(rest).filter((key) => {
            if (flagValidacao === 'NAO_VALIDADO') {
                return key.includes('Nao');
            }
            return flagValidacao === 'VALIDADO'
                ? !key.includes('Nao') && !key.includes('Descartado')
                : key.includes('Descartado');
        });

        return {
            descManifestacaoTecnica,
            respostasAvaliacaoMetodologica: respostasAvaliacaoMetodologica,
            validacaoMetodologica: keys.reduce(
                (prev, current) => {
                    prev[current.replace('Nao', '').replace('Descartado', '')] = rest[current];
                    return prev;
                },
                { tipoValidacaoMetodologica: { codgTipoValidacaoMetodologica: flagValidacao } }
            ),
        };
    };

    useEffect(() => {
        loadData();
    }, []);

    return (
        <>
            <ConfirmDialog ref={confirmRef} />
            <LayoutAnalise
                proposta={proposta}
                disableSalvar={proposta?.finalizada}
                onVoltar={() => history.push(Pages.sei.analiseMetodologica.url.list)}
                onSalvar={async () => {
                    try {
                        const dados = getAllValues();

                        await analiseMetodologicaService.salvar(id, dados);

                        printToast({
                            severity: 'success',
                            summary: Pages.sei.analiseMetodologica.title,
                            detail: Shareds.form.successUpdate,
                        });

                        loadData();
                    } catch (error) {
                        if (!errosTratados.includes(error.response?.status)) {
                            printToast({
                                severity: 'error',
                                summary: Pages.sei.analiseMetodologica.title,
                                detail: error.response?.message,
                            });
                        }
                    }
                }}
                onFinalizar={async () =>
                    confirmRef.current?.show(
                        PageMessages.sei.analiseMetodologica.confirmFinnaly,
                        async () => {
                            const dados = getAllValues();

                            if (
                                isEmpty(dados?.validacaoMetodologica?.flagFichaPreeConformidade) &&
                                isEmpty(dados?.validacaoMetodologica?.flagParecerAdqAderenciaObj) &&
                                isEmpty(dados?.validacaoMetodologica?.flagPropriedadeDesejavel)
                            ) {
                                printToast({
                                    severity: 'error',
                                    summary: Pages.sei.analiseMetodologica.title,
                                    detail: PageMessages.sei.analiseMetodologica.valid,
                                });
                                confirmRef.current.hide();
                                return;
                            }

                            try {
                                const response = await analiseMetodologicaService.finalizar(
                                    id,
                                    dados
                                );
                                confirmRef.current.hide();
                                printToast({
                                    severity: 'success',
                                    summary: Pages.sei.analiseMetodologica.title,
                                    detail: response?.data?.id
                                        ? PageMessages.sei.analiseMetodologica.successOnFinnaly
                                              .replace('{CODIGO}', response?.data?.codgIndicador)
                                              .replace('{NOME}', response?.data?.nmIndicador)
                                        : Shareds.form.successUpdate,
                                });
                                loadData();
                            } catch (error) {
                                if (!errosTratados.includes(error.response?.status)) {
                                    printToast({
                                        severity: 'error',
                                        summary: Pages.sei.analiseMetodologica.title,
                                        detail: error.response?.message,
                                    });
                                }
                            }
                        }
                    )
                }
                type={layoutAnaliseType.analiseMetodologica}
            >
                <InputGroupPergunta
                    label="1.0 METODOLOGIA DO INDICADOR"
                    classNameChildren={styles.containerChildrenPergunta}
                >
                    {perguntas.map(({ id, descPropriedadeAvaliacao }, index) => (
                        <InputPergunta
                            key={index}
                            descricao={descPropriedadeAvaliacao}
                            ref={(el) => (perguntasRef.current[id] = el)}
                            disabled={proposta?.finalizada}
                        />
                    ))}
                </InputGroupPergunta>

                <InputGroupPergunta
                    label="2.0 VALIDAÇÃO METODOLÓGICA DO INDICADOR"
                    className={styles.secondGroup}
                    classNameChildren={styles.containerChildren}
                >
                    <FormBottom
                        ref={inputsRef}
                        disabled={proposta?.finalizada}
                        codgTipoProposta={proposta?.codgTipoProposta}
                    />
                </InputGroupPergunta>
            </LayoutAnalise>
        </>
    );
}

export default AnaliseMetodologicaForm;
